import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  featured: false,
  searchText: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    featuedFilter: (state, action) => {
      state.featured = true;
    },
    featuedAll: (state, action) => {
      state.featured = false;
    },

    searchFilter: (state, action) => {
      state.searchText = action.payload;
    },
  },
});

export default filterSlice.reducer;

export const {featuedFilter, searchFilter, featuedAll} = filterSlice.actions;
